import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="h-screen w-screen bg-skgBlue text-white flex justify-center items-center flex-col space-y-4 bg-repair-pattern">
                    <p
                        className="text-5xl"
                    >
                        Ups..
                    </p>
                    <h1 className="text-white text-2xl text-center md:text-left">Der er desværre sket en fejl</h1>
                    <p
                        className="text-center md:text-left"
                    >
                        Prøv igen, eller kontakt: kundeservice@skorstensgaard.dk
                    </p>
                    <div
                        className="mt-3 space-x-2"
                    >
                        <button
                            onClick={() => this.setState({ hasError: false })}
                            className="bg-skgRed py-3 px-5 rounded-md"
                        >
                            Prøv igen
                        </button>
                        <a
                            className="rounded-md border-2 border-white py-3 px-5"
                            href={process.env.REACT_APP_WEBSITE_URL}
                        >
                            Gå til forsiden
                        </a>
                    </div>
                </div>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;